import React, { useEffect } from "react";
import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Home Page/Footer";
import "./Disclaimer.css"; // Reuse the simple styling

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />
            <div className="container-fluid disclaimer-page posp-layout-padding">
                <div className="row">
                    <div className="col-12">
                        <h1>Privacy Policy</h1>

                        <p><strong>Introduction</strong></p>
                        <p>
                            Vibe Insurance Broking and Advisory Services Private Limited (“Vibe”) recognizes the importance of protecting the privacy of its users and is committed to safeguarding the integrity, confidentiality, and security of personal information.
                            This Privacy Policy describes how we collect, use, store, disclose, and protect information obtained through our website <a href="https://policyengine.vibeins.com/">https://policyengine.vibeins.com/</a>.
                            This Privacy Policy applies to all visitors, registered users, customers, and former users of the Website. By accessing or using the Website, you agree to the terms of this Privacy Policy.
                        </p>

                        <p><strong>Consent and Authorization</strong></p>
                        <p>
                            By registering or using our website, you expressly authorize Vibe and its authorized representatives, affiliates, and business partners to contact you via phone calls, SMS, email, or other electronic communication regarding products, services, policy updates, and related offerings.
                            You consent to receive such communications even if your number is registered under DND/DNC/NCPR registries, to the extent permitted under applicable law.
                            This consent remains valid until your account is deactivated or you withdraw consent in writing.
                        </p>

                        <p><strong>Collection of Information</strong></p>
                        <p><strong>1. Personal Information</strong></p>
                        <p>
                            We may collect personal information including, but not limited to: <br />
                            • Full name <br />
                            • Contact details (email address, phone number) <br />
                            • Mailing address <br />
                            • Date of birth <br />
                            • KYC and identification details <br />
                            • Insurance-related information required for policy issuance
                        </p>
                        <p>
                            Such information is collected when you: <br />
                            • Register on the Website <br />
                            • Submit forms or applications <br />
                            • Purchase or inquire about insurance products <br />
                            • Interact with our services or support channels <br />
                            You may browse certain sections anonymously. However, refusal to provide personal information may limit access to some services.
                        </p>

                        <p><strong>2. Non-Personal Information</strong></p>
                        <p>
                            We may automatically collect non-personal information such as: <br />
                            • Browser type and version <br />
                            • Device type and operating system <br />
                            • IP address <br />
                            • ISP details <br />
                            • Website usage patterns and analytics data
                        </p>

                        <p><strong>Purpose of Data Collection and Use</strong></p>
                        <p>
                            Your information may be used for the following purposes: <br />
                            • Processing insurance applications and service requests <br />
                            • Responding to queries and providing customer support <br />
                            • Policy administration and servicing <br />
                            • Compliance with legal and regulatory requirements <br />
                            • Improving Website functionality and user experience <br />
                            • Conducting analytics and service optimization <br />
                            • Sending relevant service-related communications and notifications <br />
                            • Fraud prevention and risk management
                        </p>

                        <p><strong>Use of Data for Wellness Services</strong></p>
                        <p>
                            Where applicable and with your consent, Vibe may use relevant information to provide wellness-related services, value-added benefits, health awareness programs, and preventive care initiatives associated with insurance offerings. Such use will be limited to legitimate business purposes and handled in accordance with applicable privacy and data protection laws.
                        </p>

                        <p><strong>Data Security</strong></p>
                        <p>
                            We implement reasonable administrative, technical, and physical safeguards to protect your information against unauthorized access, misuse, alteration, or loss.
                            While we strive to protect your data, no system can guarantee absolute security. Users are advised to maintain confidentiality of login credentials and exercise caution while sharing information.
                        </p>

                        <p><strong>Information Sharing and Disclosure</strong></p>
                        <p>
                            We may share personal information in the following circumstances: <br />
                            • With insurers, TPAs, service providers, and partners for policy issuance and servicing <br />
                            • Within Vibe on a need-to-know basis under confidentiality obligations <br />
                            • When required by law, court order, or regulatory authority <br />
                            • To prevent fraud, investigate offenses, or enforce legal rights <br />
                            • In connection with mergers, acquisitions, or business restructuring <br />
                            We do not sell personal data to third parties.
                        </p>

                        <p><strong>Cookies and Tracking Technologies</strong></p>
                        <p>
                            Our website may use cookies and similar technologies to: <br />
                            • Enhance user experience <br />
                            • Maintain session information <br />
                            • Analyze Website performance <br />
                            Cookies do not typically contain personally identifiable information. Users may disable cookies through browser settings, though some features may be affected.
                        </p>

                        <p><strong>Third-Party Links</strong></p>
                        <p>
                            Our website may contain links to third-party websites. Vibe is not responsible for the privacy practices or content of such websites. Users should review their privacy policies separately.
                        </p>

                        <p><strong>Retention of Information</strong></p>
                        <p>
                            We retain personal information only as long as necessary for business, legal, or regulatory purposes, or as required under applicable law.
                        </p>

                        <p><strong>Modifications to this Privacy Policy</strong></p>
                        <p>
                            Vibe reserves the right to update this Privacy Policy periodically. Updated versions will be posted on the Website with revised effective dates. Users are encouraged to review this policy regularly.
                        </p>

                        <p><strong>Acceptance of the Privacy policy</strong></p>
                        <p>
                            By using the Website, you acknowledge and agree to this Privacy Policy. If you do not agree, please discontinue use of the website. Continued use following updates constitutes acceptance of the revised policy.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
